import { createAction } from "@reduxjs/toolkit";

interface IResetForms {}

export const resetFormAction = createAction<IResetForms>("resetFormAction");
